import { faXmark } from '@document-crunch/pro-regular-svg-icons'

import { Icon } from '@dc-shared-web/components/base/Icon'
import { Button } from '@dc-shared-web/components/shadcn'

export const Chip = ({
  value,
  onRemove,
}: {
  value: { value: string; label: string }
  onRemove: (chipVal: string) => void
}) => {
  return (
    <div className='tw-bg-neutral-100 tw-px-2 tw-py-1 tw-text-neutral-700 tw-rounded tw-font-normal tw-text-sm tw-flex tw-items-center tw-mr-1 tw-gap-2'>
      <div>{value.label || value.value}</div>
      <Button
        variant='primitive'
        size='mini'
        onClick={() => onRemove(value.value)}
        className='tw-p-0'
        aria-label={`Remove ${value.label || value.value}`}
      >
        <Icon icon={faXmark} size='sm' />
      </Button>
    </div>
  )
}
